import * as Yup from "yup";
import { Strings } from "@app/constants";

export const addSalesPersonSchema = Yup.object({
  firstName: Yup.string()
    .required(Strings.validation.fieldRequired(Strings.common.firstName))
    .test(
      "no-leading-whitespace",
      "First name should not start with white spaces",
      (value) => (value ? !/^\s/.test(value) : false)
    ),
  lastName: Yup.string()
    .required(Strings.validation.fieldRequired(Strings.common.lastName))
    .test(
      "no-leading-whitespace",
      "Last name should not start with white spaces",
      (value) => (value ? !/^\s/.test(value) : false)
    ),
  email: Yup.string()
    .email(Strings.validation.invalidEmail)
    .required(Strings.validation.fieldRequired(Strings.salesPerson.email)),
  phone: Yup.string()
    .required(Strings.validation.fieldRequired(Strings.common.phone))
    .test(
      "no-leading-whitespace",
      "Contact number should not start with white spaces",
      (value) => (value ? !/^\s/.test(value) : false)
    ),
  // role: Yup.string().required("Role is required"),
  // assignCustomer: Yup.string().required("Customer is required"),
  profileImage: Yup.mixed<File>().nullable(),
});
